<template>
    <div class="py-2">
        <div class="fw-600 border-bottom border-color-gray-700 pb-1 mb-2">{{ $t(`답변 작성/수정 관련`) }}</div>
        <section class="mb-5">
            <div class="faq-group shadow-sm">
                <b-button v-b-toggle.collapse-2 block :pressed.sync="faqToggle[2]" variant="light"
                          class="d-flex justify-content-between" @click="toggleGroup(2)">
                    <span class="text-left">{{ $t(`Q1. '완료하기'에 체크하면 답변을 다시 수정할 수 없나요?`) }}</span>
                    <fa v-if="is_group_active[2]" icon="angle-down" class="mx-2 float-right"></fa>
                    <fa v-else icon="angle-up" class="mx-2 float-right"></fa>
                </b-button>
                <b-collapse id="collapse-2">
                    <div class="faq-answer f-95 gray-600 mb-1">
                        {{ $t(`'완료하기'는 진행 현황을 확인하는 데 사용됩니다. 최종 제출 전에는 '완료됨'을 풀고 수정 가능합니다.`) }}
                    </div>
                </b-collapse>
            </div>

            <div class="faq-group shadow-sm">
                <b-button v-b-toggle.collapse-1 block :pressed.sync="faqToggle[1]" variant="light"
                          class="d-flex justify-content-between" @click="toggleGroup(1)">
                    <span class="text-left"> {{ $t(`Q2. 작성한 답변을 문서로 다운로드 받을 수 있나요?`) }} </span>
                    <fa v-if="is_group_active[1]" icon="angle-down" class="mx-2 float-right"></fa>
                    <fa v-else icon="angle-up" class="mx-2 float-right"></fa>
                </b-button>
                <b-collapse id="collapse-1">
                    <div class="faq-answer f-95 gray-600 mb-1">
                        {{ $t(`답변 입력 페이지 오른쪽에 '인쇄/다운로드'를 통해 pdf 출력 및 파일 다운로드가 가능합니다.`) }} <br>
                        {{
                            $t(`다만, 인터넷 익스플로러를 사용하실 경우 해당 기능을 이용하실 수 없으므로 반드시 크롬(Chrome) 또는 엣지(Edge) 브라우저 등을 이용해 주세요.`)
                        }}<br>
                        {{ $t(`자세한 사용 방법은 아래 '사용 매뉴얼'을 참고해주세요.`) }}
                    </div>
                </b-collapse>
            </div>
        </section>

        <div class="fw-600 border-bottom border-color-gray-700 pb-1 mb-2"> {{ $t(`결과 보고서 관련`) }}</div>
        <section class="mb-5">
            <div class="faq-group shadow-sm">
                <b-button v-b-toggle.collapse-4 block :pressed.sync="faqToggle[4]" variant="light"
                          class="d-flex justify-content-between" @click="toggleGroup(4)">
                    <span class="text-left">{{ $t(`Q1. 결과보고서는 언제 확인할 수 있나요?`) }}</span>
                    <fa v-if="is_group_active[4]" icon="angle-down" class="mx-2 float-right"></fa>
                    <fa v-else icon="angle-up" class="mx-2 float-right"></fa>
                </b-button>
                <b-collapse id="collapse-4">
                    <div class="faq-answer f-95 gray-600 mb-1"> {{ $t(`결과보고서는 평가 완료 후 배포되며, 평가 완료시 이메일로 안내 됩니다.`) }}
                    </div>
                </b-collapse>
            </div>
        </section>

        <div class="fw-600 border-bottom border-color-gray-700 pb-1 mb-2">{{ $t(`시스템 사용 방법`) }}</div>

        <SupplyManual v-if="get_current_app_env === 'supply'">
            <template v-slot="{ manualLink }">
                <b-button :href="manualLink" variant="blue-border" block target="_blank">
                    {{ $t(`시스템 사용 매뉴얼`) }}
                    <fa icon="book" class="ml-1"></fa>
                </b-button>
            </template>
        </SupplyManual>
        <HMCManual v-if="get_current_app_env === 'hmc' || get_current_app_env === 'hmc-theme'">
            <template v-slot="{ manualLink }">
                <b-button :href="manualLink" variant="blue-border" block target="_blank">
                    {{ $t(`시스템 사용 매뉴얼`) }}
                    <fa icon="book" class="ml-1"></fa>
                </b-button>
            </template>
        </HMCManual>
        <HyundaiManual v-if="get_current_app_env === 'hyundai'">
            <template v-slot="{ manualLink }">
                <b-button :href="manualLink" variant="blue-border" block target="_blank">
                    {{ $t(`플랫폼 사용 매뉴얼`) }}
                    <fa icon="book" class="ml-1"></fa>
                </b-button>
            </template>
        </HyundaiManual>
        <KiaManual v-if="get_current_app_env === 'kia'">
            <template v-slot="{ manualLink }">
                <b-button :href="manualLink" variant="blue-border" block target="_blank">
                    {{ $t(`시스템 사용 매뉴얼`) }}
                    <fa icon="book" class="ml-1"></fa>
                </b-button>
            </template>
        </KiaManual>
        <KSteelManual v-if="get_current_app_env === 'ksteel'">
            <template v-slot="{ manualLink }">
                <b-button :href="manualLink" variant="blue-border" block target="_blank">
                    {{ $t(`시스템 사용 매뉴얼`) }}
                    <fa icon="book" class="ml-1"></fa>
                </b-button>
            </template>
        </KSteelManual>
        
        <template v-if="get_current_app_env === 'ksteel'">
            <div class="fw-600 border-bottom border-color-gray-700 pb-1 mb-2 mt-5">{{ $t(`Code별 평가 기준`) }}</div>
            <KSteelCodeGuide>
                <template v-slot="{ manualLink }">
                    <b-button :href="manualLink" variant="blue-border" block target="_blank">
                        {{ $t(`Code별 평가 기준`) }}
                        <fa icon="file-contract" class="ml-1"></fa>
                    </b-button> 
                </template>
            </KSteelCodeGuide>
        </template>
    </div>
</template>

<script>
import {checkAppEnv} from '@shared/utils/common';
import HMCManual from '@shared/components/utils/Manuals/HMCManual.vue';
import KSteelManual from '@shared/components/utils/Manuals/KSteelManual.vue';
import SupplyManual from '@shared/components/utils/Manuals/SupplyManual.vue';
import HyundaiManual from '@shared/components/utils/Manuals/HyundaiManual.vue';
import KiaManual from '@shared/components/utils/Manuals/KiaManual.vue';
import KSteelCodeGuide from '@shared/components/utils/Manuals/KSteelCodeGuide.vue';

export default {
    name: 'FAQ',
    components: {KSteelCodeGuide, KSteelManual, HMCManual, SupplyManual, HyundaiManual, KiaManual},
    data() {
        return {
            // publicPath: process.env.BASE_URL,
            visible: true,
            is_group_active: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
            faqToggle: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        };
    },
    computed: {
        get_current_app_env() {
            return checkAppEnv();
        }
    },
    methods: {
        toggleGroup(x) {
            this.$set(this.is_group_active, x, !this.is_group_active[x]);
        }
    }
};


</script>

<style scoped>
.faq-group {
    text-align: left;
    margin-bottom: 0.5rem;

}

.faq-answer {
    padding: 0.75rem 1rem;
    line-height: 1.8;
}

</style>
